import { useEffect, useState } from 'react'
import { api } from '../api/client'

interface ColorTheme {
  bg: string
  fg: string
  color1: string
  color2: string
}

interface IdentityWithTheme {
  color_theme: ColorTheme | null
}

const STYLE_ID = 'author-page-theme'

function injectAuthorTheme(ct: ColorTheme) {
  let el = document.getElementById(STYLE_ID) as HTMLStyleElement | null
  if (!el) {
    el = document.createElement('style')
    el.id = STYLE_ID
    document.head.appendChild(el)
  }
  el.textContent = `#page-content{--color-bg:${ct.bg};--color-fg:${ct.fg};--color-1:${ct.color1};--color-2:${ct.color2};background-color:${ct.bg};color:${ct.fg};}`
}

function removeAuthorTheme() {
  document.getElementById(STYLE_ID)?.remove()
}

export function useAuthorTheme(username: string | undefined): {
  colorTheme: ColorTheme | null
} {
  const [colorTheme, setColorTheme] = useState<ColorTheme | null>(null)

  useEffect(() => {
    if (!username) return
    api.get<IdentityWithTheme>(`/users/${username}/identity`)
      .then((card) => {
        const ct = card.color_theme ?? null
        setColorTheme(ct)
        if (ct) injectAuthorTheme(ct)
      })
      .catch(() => null)

    return () => {
      removeAuthorTheme()
      setColorTheme(null)
    }
  }, [username])

  return { colorTheme }
}
